import { useAppSelector } from 'app/hooks';
import { useEffect } from 'react';
import {
  selectInTimeshare,
  selectTimeshareUsers,
} from 'features/spectrasWebSocketServer/spectrasWebSocketServerSlice';

import { queryClient } from 'lib/react-query';

export const useTimeshareMessages = () => {
  const inTimeshare = useAppSelector(selectInTimeshare);
  const timeshareUsers = useAppSelector(selectTimeshareUsers);

  useEffect(() => {
    queryClient.invalidateQueries(['snapshot']);
    queryClient.invalidateQueries(['snapshots']);
  }, [timeshareUsers]);

  return { inTimeshare, timeshareUsers };
};
